import { Injectable } from '@angular/core';
import {ApiClass} from "../../../../../../data/class/api-class";
import {map} from "rxjs";
import {IExpressLeague} from "../../interfaces/iexpress-league";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiExpressLeagueService extends ApiClass {

  constructor() {
    super()
    this.path = 'expressLeague'
  }

  getExpressLeague(data: any) {
    return this.postCollection(data, 'get').pipe(map((r) => r as {error: boolean; msg:string; data: IExpressLeague}))
  }

  createExpressLeague(data: any) {
    return this.postCollection(data).pipe(map((r) => r as {error: boolean; msg: string; data: {expressLeague: IExpressLeague, token: string } }))
  }

  sendSms(data: any) {
    return this.postCollection(data, 'sendSMS').pipe(map((r) => r as {error: boolean; msg: string; data: any }))
  }
}
